module.exports = __webpack_public_path__ + "static/smn-eccca752c4362ddc065f9ee5d0d31ca0.jpg";